'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1024 512c0-282.768-229.23-512-512-512s-512 229.232-512 512c0 282.77 229.23 512 512 512s512-229.228 512-512zM96 512c0-229.75 186.25-416 416-416s416 186.25 416 416c0 229.75-186.25 416-416 416s-416-186.248-416-416z' }),
        React.createElement('path', { d: 'M256 544l256 256 256-256-96-96-96 96v-288h-128v288l-96-96z' })
    ));
};